<script>
import {Link} from "@inertiajs/vue3";
import {useThemeStore} from "@/js/store/ThemeStore.js";
import SocialsListIcons from "@js/components/TopBar/Components/SocialsListIcons.vue";
import {useCallbackFormsStore} from "@js/store/CallbackFormsStore.js";
import TopBarMenu from "@js/components/TopBar/Components/TopBarMenu.vue";
import IconPhone from "@js/components/Icons/IconPhone.vue";
import FirstPhone from "@js/components/Sections/Links/FirstPhone.vue";
import SecondPhone from "@js/components/Sections/Links/SecondPhone.vue";
import IconLogo from "@js/components/Icons/IconLogo.vue";
import IconCart from "@js/components/Icons/IconCart.vue";
import {useCartStore} from "@js/store/CartStore.js";
import IconMapPoint from "@js/components/Icons/IconMapPoint.vue";
import IconEnvelope from "@js/components/Icons/IconEnvelope.vue";
import IconClock from "@js/components/Icons/IconClock.vue";
import IconSearch from "@js/components/Icons/IconSearch.vue";
import IconWhatsApp from "@js/components/Icons/IconWhatsApp.vue";
import IconTelegram from "@js/components/Icons/IconTelegram.vue";
import IconClock2 from "@js/components/Icons/IconClock2.vue";

export default {
    name: "TopBar",
    components: {
        IconClock2,
        IconTelegram,
        IconWhatsApp,
        IconSearch,
        IconClock,
        IconEnvelope,
        IconMapPoint,
        IconCart,
        IconLogo,
        SecondPhone,
        FirstPhone,
        IconPhone,
        TopBarMenu,
        SocialsListIcons,
        Link
    },
    setup() {
        const themeStore = useThemeStore()
        const callbackStore = useCallbackFormsStore()
        const cartStore = useCartStore()

        return {themeStore, callbackStore, cartStore}
    }
}
</script>

<template>
    <header class="shadow-lg">
        <nav class="block md:hidden bg-white border-b border-gray-300">
            <div class="max-w-screen-xl px-4 py-2 mx-auto">
                <div class="flex justify-between items-center">
                    <Link :href="route('home')" class="flex items-center space-x-3" aria-label="Лого">
                        <img src="@img/logo/logo_black.webp" class="h-12" alt="Лого" title="Лого"/>
                    </Link>
                    <div class="flex flex-col justify-center items-end">
                        <FirstPhone class="text-black text-[12px] font-medium"/>
                        <a href="https://yandex.com/maps/-/CHqNiWk4" target="_blank" rel="nofollow"
                           class="text-black text-[11px] font-medium">
                            Домодедово, Промышленная ул. 38
                        </a>
                    </div>
                </div>
            </div>
        </nav>
        <nav class="hidden md:block border-b border-b-[#e8e8e8]">
            <div class="max-w-screen-xl mx-auto">
                <div class="flex justify-between items-center">
                    <ul class="flex flex-row font-medium mt-0 text-sm space-x-4">
                        <li class="flex items-center">
                            <div class="flex items-center ps-4 gap-2">
                                <a href="https://api.whatsapp.com/send/?phone=79256649222&text&type=phone_number&app_absent=0"
                                   target="_blank" aria-label="WhatsApp"
                                   class="group w-7 h-7 flex items-center justify-center bg-whatsapp border-2 border-whatsapp hover:bg-transparent rounded p-1 transition">
                                    <IconWhatsApp class="text-white group-hover:text-whatsapp"/>
                                </a>
                                <a href="https://t.me/Dorozhnyeplity" target="_blank" aria-label="Telegram"
                                   class="group w-7 h-7 flex items-center justify-center bg-telegram border-2 border-telegram hover:bg-transparent rounded p-1 transition">
                                    <IconTelegram class="text-white group-hover:text-telegram"/>
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="flex items-center px-4 py-3">
                                <IconClock2 class="w-4 h-4 me-2 text-indigo-600"/>
                                <div class="text-[12px] font-semibold">
                                    Пн-Вс: Круглосуточно
                                </div>
                            </div>
                        </li>
                        <li>
                            <div class="flex items-center px-4 py-3">
                                <IconMapPoint class="w-4 h-4 me-2 text-indigo-600"/>
                                <a href="https://yandex.com/maps/-/CHqNiWk4" target="_blank" rel="nofollow"
                                   class="text-[12px] font-semibold hover-white-decor hover:text-indigo-600 transition">
                                    Домодедово, Промышленная ул. 38
                                </a>
                            </div>
                        </li>
                        <li>
                            <div class="flex items-center px-4 py-3">
                                <IconEnvelope class="w-4 h-4 me-2 text-indigo-600"/>
                                <a href="mailto:sale@dorozhnyeplity.ru" target="_blank" rel="nofollow"
                                   class="text-[12px] font-semibold hover-white-decor hover:text-indigo-600 transition">
                                    sale@dorozhnyeplity.ru
                                </a>
                            </div>
                        </li>
                    </ul>
                    <ul class="flex flex-row font-medium mt-0 space-x-10 text-[12px] items-center">
                        <li>
                            <div class="flex items-center">
                                <div
                                    class="flex items-center px-4 py-3 group hover:text-indigo-600 transition cursor-pointer hover:bg-[#f4f5f7]">
                                    <IconSearch
                                        class="w-4 h-4 me-2 text-indigo-600 group-hover:text-indigo-600 transition"/>
                                    Поиск
                                </div>
                                <div @click.prevent="callbackStore.showCallbackPopup"
                                     class="max-lg:hidden flex items-center px-4 py-3 group hover:text-indigo-600 transition cursor-pointer hover:bg-[#f4f5f7]">
                                    <IconPhone
                                        class="w-5 h-5 me-2 text-indigo-600 group-hover:text-indigo-600 transition"/>
                                    Заказать звонок
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </nav>
        <div class="border-b border-b-[#e8e8e8]">
            <nav class="hidden md:block bg-transparent border-gray-200">
                <div class="max-w-screen-xl flex flex-wrap items-center justify-between mx-auto px-4 h-[80px]">
                    <Link :href="route('home')" class="flex items-center space-x-3">
                        <img src="@img/logo/logo_black.webp" class="h-[60px] w-[128px]" alt="Лого" title="Лого"/>
                    </Link>
                    <div class="flex items-center md:order-2 space-x-3 md:space-x-0 gap-7">
                        <div class="flex flex-col gap-1 max-lg:hidden">
                            <div class="group flex items-center gap-1">
                                <IconPhone class="group-hover:text-indigo-600 w-5 h-5 transition"/>
                                <FirstPhone class="group-hover:text-indigo-600 text-sm font-medium"/>
                            </div>
                            <div class="group flex items-center gap-1">
                                <IconPhone class="group-hover:text-indigo-600 w-5 h-5 transition"/>
                                <SecondPhone class="group-hover:text-indigo-600 text-sm font-medium"/>
                            </div>
                        </div>
                        <Link :href="route('cart')"
                              data-tooltip-target="tooltip-cart" data-tooltip-placement="left"
                              aria-label="Перейти в корзину"
                              class="group relative flex items-center justify-center text-white border-2 border-indigo-600 bg-transparent rounded-full w-12 h-12 hover:bg-indigo-600 focus:outline-none transition">
                            <IconCart class="w-7 h-7 text-indigo-600 group-hover:text-white transition"/>
                            <span v-if="cartStore.cart.length > 0"
                                  class="absolute -top-1 -right-0.5 ms-1 backdrop-blur-xl border-2 border-indigo-600 bg-indigo-600 w-5 h-5 flex items-center justify-center rounded-full text-[9px] font-bold text-white group-hover:bg-white group-hover:text-indigo-600 transition overflow-hidden">
                                {{ cartStore.cart.length }}
                            </span>
                        </Link>
                        <!--                        <Link :href="route('cart')" type="button"-->
                        <!--                              class="text-black hover:text-white transition group inline-flex items-center border-2 border-indigo-600 backdrop-blur-xl bg-white/5 hover:bg-indigo-600 font-bold rounded-full text-sm px-8 py-2 text-center text-indigo-600 hover:text-white transition">-->
                        <!--                            <IconCart-->
                        <!--                                class="w-5 h-5 text-indigo-600 hover:text-white group-hover:text-white transition me-1"/>-->
                        <!--                            <span v-if="cartStore.cart.length > 0"-->
                        <!--                                  class="absolute ms-1 backdrop-blur-xl bg-indigo-600 w-5 h-5 flex items-center justify-center rounded-full text-[9px] font-bold text-white group-hover:bg-white group-hover:text-indigo-600 transition overflow-hidden">-->
                        <!--                                {{ cartStore.cart.length }}-->
                        <!--                            </span>-->
                        <!--                        </Link>-->
                    </div>
                    <TopBarMenu/>
                </div>
            </nav>
        </div>
    </header>
</template>

<style lang="scss" scoped>
header {
    //border-bottom: 1px solid hsla(0, 0%, 100%, .3);
    //height: 60px;

    .menu-block:not(:last-child) {
        border-right: 1px solid hsla(0, 0%, 100%, .3);
    }

    .header-logo {
        display: flex;
        align-items: center;
        white-space: nowrap;
        padding-right: 24px;
        cursor: pointer;

        img {
            height: 60px;
        }
    }

    .menu-block {
        align-items: center;
        display: flex;
        padding: 0 5px;
        height: 60px;
    }

    .header-nav {
        //height: 60px;
        padding: 0 24px;
    }

    .header-nav-list {
        list-style: none;

        .header-nav-item:not(:last-of-type) {
            margin-right: 14px;
        }

        .header-nav-item {
            .header-nav-route_name {
                transition: border-bottom-color .2s ease-in-out;
                padding-bottom: 10px;
                font-size: 14px;
                color: #fff;
                border-bottom: 3px solid transparent;
                line-height: 120%;
                text-decoration: none;
                text-align: center;
                font-weight: 600;
            }

            .header-nav-route_name:hover {
                border-bottom-color: red;
            }
        }
    }

    .header-login {
        height: 60px;
        padding-left: 24px;
        padding-bottom: 12px;

        .header-login-inner {
            line-height: 120%;
        }
    }

    .header-nav-burger {
        display: none;
    }

    .menu-chevron {
        line-height: 1;
    }
}

@media (max-width: 1199.98px) {
    header {
        .header-nav {
            width: auto;
        }

        .header-nav-list {
            display: none;
        }

        .header-nav-burger {
            font-weight: 600;
            font-size: 14px;
            display: flex;
            padding-bottom: 18px;
        }
    }
}

@media (max-width: 575.98px) {
    header {
        .header-nav {
            order: 3;
            width: 50%;
            border-left: none;
            height: 40px;
            padding: 0;
            justify-content: center;
        }

        .header-nav-burger {
            align-self: center;
            padding-bottom: 0;
        }
    }
}

</style>
